const formato = (num) =>{
    const numberToConvert = ((num/100).toFixed(2)).toString().split('.')
    let splitter = numberToConvert[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    if(numberToConvert[1]){
        splitter += "." + numberToConvert[1].substr(0,3);
    }
    return splitter;
}


const renderRecomendations = (products) =>{
    const nodoRecommendations = document.querySelector('#render-collection-recommendations');


    products.forEach((product)=>{
        console.log(product);

        const card = document.createElement('div');
        card.classList.add('card-product-recommendation');
        card.innerHTML =    `
                                <a href="${product.url}" class="card-product-recommendation-box">
                                <div class="card-product-recommendation-box__img">
                                    <img src="${product.featured_image}" alt="" width="50px"/>
                                </div>
                                <div class="card-product-recommendation-box__text">
                                    <p>${product.title}</p>
                                    <small>$ ${formato(product.compare_at_price)}</small>
                                </div>
                                </a>
                            `;
        nodoRecommendations.append(card);
    })
}





window.addEventListener('DOMContentLoaded', ()=>{
    const nodoId = document.querySelectorAll('.first-product-recommendation');

    nodoId.forEach((nodoProduct)=>{
        const idProduct = nodoProduct.dataset.id_first_product;
        fetch(`/recommendations/products.json?product_id=${idProduct}&limit=3`)
        .then((response)=> response.json())
        .then((result)=>{
          renderRecomendations(result.products)
        })
    })
})